import { render, staticRenderFns } from "./payAdd.vue?vue&type=template&id=6132b158&scoped=true"
import script from "./payAdd.vue?vue&type=script&lang=js"
export * from "./payAdd.vue?vue&type=script&lang=js"
import style0 from "./payAdd.vue?vue&type=style&index=0&id=6132b158&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132b158",
  null
  
)

export default component.exports